// expects to be linked in together with the parse route

export default {
    data() {
        return {
            entityEndpoints: {
                'company': 'companies'
            },
            entityTree: {
                children: [{
                    name: 'company', 
                    children: [
                        { 
                            name: 'domain', 
                            children: [
                                {name: 'product' },
                                {name: 'visitor' },
                                {name: 'campaign', children: [ { name: 'variant' } ]},
                                {name: 'form'}
                            ]
                        }
                    ]
                },
                {
                    name: 'nstemplate'
                }]
            }
        }
    },
    computed: {
    },
    watch: {
        $route() {
            //console.debug('route changed, loading entities');
            this.loadEntities();
        }
    },
    methods: {
        getStoreModule(entity) {
            return this.entityEndpoints[entity] || `${entity}s`;
        },
        loadEntity(node) {
            // this is the root, just run on children
            if(!node.name) {
                node.children.forEach(c => this.loadEntity(c));
                return;
            }

            if(!this[node.name]) {
                return;
            }
            // if url contains the entity parameter
            // check if any item is loaded
            var sm = this.getStoreModule(node.name);
            
            var item = this.$store.state[sm].item;
            
            var nc = node.children || [];

            // if the current item is loaded, do nothing
            if(!(item && item.id == this[node.name])) {
                //console.debug(`Dispatching get for ${node.name} with id ${this[node.name]} from ${this.$options.name}`);
                // reset the value so skeletons are shown when loading
                this.$store.commit(`${sm}/item`, {value: null});
                this.$store.dispatch(`${sm}/get`, { id: this[node.name] });
                nc.forEach(c => {
                    // remove lists if present 
                    // (this cant be done for the entity itself in the loadEntity as it would unncecessarily erase loaded list when traversing the tree)   
                    var csm = this.getStoreModule(c.name);
                    var list = this.$store.state[csm].list;
                    //console.debug(`Erasing list for ${csm}`);
                    if(list) {
                        this.$store.commit(`${csm}/list`, {value: null});
                        this.$store.commit(`${csm}/nextToken`, {value: null});
                    }
                })
            }
            
            // in any case, run loadEntity on each children
            nc.forEach(c => this.loadEntity(c));
        },
        loadEntities() {
            //console.debug('loading entities');
            // this mixin is used in the App component where user is mapped from store
            if(this.user) {
                this.loadEntity(this.entityTree);
            }
              
        },
        /*
        companyLoad() {
            if(this.company) {
              this.$store.dispatch('companies/get', { id: this.company });
            }
        },
        domainLoad() {
            if(this.domain) {
                this.$store.dispatch('domains/get', { id: this.domain });
            }
        }
        */
    }
}